/* SP Últimos vistos — registra el producto actual y pinta los vistos recientemente.
   Carrusel flex + scrollBy (Regla 1/4). Idempotente (guard dataset). Sin dependencias.
   Datos reales vía /products/<handle>.js (endpoint nativo de Shopify). */
(function () {
  var KEY = 'sp_recently_viewed';

  function readList() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }
  function writeList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function money(cents) {
    // Formato es-ES sencillo: 105,10 €. Respeta currency del store vía Intl si está.
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
        style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LABELS = { in: 'Recíbelo en 24/48h', sold: 'Agotado' };

  function card(p) {
    // URL del idioma actual (el .js puede devolver la ruta sin prefijo).
    var url = ROOT + 'products/' + p.handle;
    var art = document.createElement('article');
    art.className = 'sp-pcard';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var pct = onSale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    art.innerHTML =
      '<a class="sp-pcard__media" href="' + url + '">' +
        (img ? '<img class="sp-pcard__img" src="' + img + '" alt="' + (p.title || '') + '" loading="lazy">' : '<div class="sp-pcard__img"></div>') +
        '<div class="sp-pcard__badges">' + (onSale ? '<span class="sp-pcard__badge sp-pcard__badge--off">-' + pct + '%</span>' : '') + '</div>' +
      '</a>' +
      '<div class="sp-pcard__body">' +
        (p.vendor ? '<p class="sp-pcard__brand">' + p.vendor + '</p>' : '') +
        '<a class="sp-pcard__name" href="' + url + '">' + p.title + '</a>' +
        '<div class="sp-pcard__prices"><span class="sp-pcard__price">' + money(p.price) + '</span>' +
        (onSale ? '<span class="sp-pcard__price-old">' + money(p.compare_at_price) + '</span>' : '') + '</div>' +
        (p.available !== false
          ? '<p class="sp-pcard__stock sp-pcard__stock--in"><span class="sp-pcard__dot"></span>' + LABELS.in + '</p>'
          : '<p class="sp-pcard__stock sp-pcard__stock--out"><span class="sp-pcard__dot"></span>' + LABELS.sold + '</p>') +
      '</div>';
    return art;
  }

  function initSection(sec) {
    if (sec.dataset.spRecentBound === '1') return;
    sec.dataset.spRecentBound = '1';
    LABELS.in = sec.getAttribute('data-label-in') || LABELS.in;
    LABELS.sold = sec.getAttribute('data-label-sold') || LABELS.sold;

    var current = sec.dataset.currentHandle || '';
    var max = parseInt(sec.dataset.max || '8', 10);
    var list = readList().filter(function (h) { return h && h !== current; });

    // Registrar el producto actual al frente (para próximas visitas).
    if (current) {
      var updated = [current].concat(readList().filter(function (h) { return h !== current; }));
      writeList(updated.slice(0, 20));
    }

    var track = sec.querySelector('[data-sp-recent-track]');
    if (!track || !list.length) return; // hidden permanece si no hay histórico

    var toFetch = list.slice(0, max);
    Promise.all(toFetch.map(function (h) {
      return fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (p) { track.appendChild(card(p)); });
      if (track.children.length) { sec.hidden = false; toggleNav(); syncArrows(); }
    });

    var nav = sec.querySelector('.sp-recent__nav');
    var prev = sec.querySelector('[data-sp-recent-prev]');
    var next = sec.querySelector('[data-sp-recent-next]');

    // Ocultar controles si no hay overflow (menos productos que columnas visibles).
    function toggleNav() {
      if (!nav) return;
      nav.style.display = (track.scrollWidth - track.clientWidth > 2) ? '' : 'none';
    }
    function syncArrows() {
      // flechas siempre activas (bucle); solo se ocultan sin overflow (toggleNav)
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }
    function step(dir) {
      var first = track.firstElementChild;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '14') || 14;
      var w = first ? first.offsetWidth + gap : track.clientWidth / 5;
      var max = track.scrollWidth - track.clientWidth;
      if (dir > 0 && track.scrollLeft >= max - 2) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max, behavior: 'smooth' }); }
      else { track.scrollBy({ left: dir * w, behavior: 'smooth' }); }
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', function () { toggleNav(); syncArrows(); });
  }

  function initAll() {
    document.querySelectorAll('[data-sp-recent]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
